import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom'

class Deltaker extends Component {
    constructor(props) {
        super(props);
        this.handleIkkeMoedtChange = this.handleIkkeMoedtChange.bind(this);
        this.handleDeltakerClick = this.handleDeltakerClick.bind(this);
        this.handleCaciobChange = this.handleCaciobChange.bind(this);
    }

    render() {
        const {deltaker, caciobPaaProeve, caciobKatalogNr, reserveCaciobKatalogNr, delPartiCheckedIn, hovedparti} = this.props;

        const katalogNr = deltaker.hund.katalogNr;
        const regNr = deltaker.hund.regNr;
        let premiegrad = deltaker.hund.resultat.premiegrad;
        const roedtKort = deltaker.hund.resultat.roedtKort;
        if (deltaker.hund.resultat.roedtKort) {
            premiegrad = "DISK";
        }
        const poengTotalt = deltaker.hund.resultat.poengTotalt;
        const plassering = deltaker.hund.resultat.plassering;
        const ikkeMoedt = deltaker.hund.resultat.ikkeMoedt;
        let statusOk = false;
        if (roedtKort || ikkeMoedt || deltaker.hund.resultat.ekvipasjeFerdigRegistrert) {
            statusOk = true;
        }
        //   console.log("CACIOB: " + caciobKatalogNr);
        // console.log("RCACIOB: " + reserveCaciobKatalogNr);


        let disableIkkeMoedt = false;
        let disableCaciob = true;
        let disableReserveCaciob = true;

        if (premiegrad === 1  && regNr.toUpperCase().indexOf("STARTNR") === -1) {
            if (caciobKatalogNr === null || caciobKatalogNr === katalogNr) {
                disableCaciob = false;
            }
            if (reserveCaciobKatalogNr === null || reserveCaciobKatalogNr === katalogNr) {
                disableReserveCaciob = false;
            }
        }

        let caciob = false;
        if (deltaker.hund.resultat.caciob === 'CACIOB') {
            caciob = true;
            disableReserveCaciob = true;
        }


        let resCaciob = false;
        if (deltaker.hund.resultat.caciob === 'RCACIOB') {
            resCaciob = true;
            disableCaciob = true;
        }

        if (!disableCaciob && !hovedparti) {
            disableCaciob = true;
        }

        if (!resCaciob && !hovedparti) {
            disableReserveCaciob = true;
        }

        if (delPartiCheckedIn !== null) {
            disableIkkeMoedt = true;
        }


        return (
           <tr>
               <td>
                   <Link to={`/kritik/${katalogNr}` } onClick={(e) => this.handleDeltakerClick(e, ikkeMoedt)}>
                       <button className="btn btn-default" style={{"width": "100%"}} disabled={ikkeMoedt}>
                           <span className="visible-xs">{katalogNr}</span>
                           <span className="hidden-xs">{katalogNr} - {regNr}</span>
                       </button>
                   </Link>
               </td>
               <td align="center">
                   {plassering}
               </td>
               <td align="center">
                   {
                    !ikkeMoedt && !roedtKort &&
                       poengTotalt
                   }
               </td>
               <td align="center">{premiegrad}</td>
               {
                   caciobPaaProeve &&
                   <td align="center">
                       <input type="checkbox" className="large-checkbox" disabled={disableCaciob} checked={caciob} name="CACIOB" onChange={this.handleCaciobChange} />
                   </td>
               }
               {
                   caciobPaaProeve &&
                   <td align="center">
                       <input type="checkbox" className="large-checkbox" disabled={disableReserveCaciob} checked={resCaciob} name="RCACIOB" onChange={this.handleCaciobChange} />
                   </td>
               }

               <td align="center">
                   <input type="checkbox" className="large-checkbox" disabled={disableIkkeMoedt} onChange={this.handleIkkeMoedtChange} checked={ikkeMoedt} />
               </td>
               <td align="center">
                   {
                       statusOk &&
                           <span style={{"color":"green"}}>OK</span>
                   }

               </td>
           </tr>
        );
    }

    handleDeltakerClick(e, ikkeMoedt) {
        if (ikkeMoedt) {
            e.preventDefault();
        }
    }

    handleIkkeMoedtChange(event) {
        const katalogNr = this.props.deltaker.hund.katalogNr;
        this.props.ikkeMoedtOppdatert(katalogNr, event.target.checked);
    }

    handleCaciobChange(event) {
        const katalogNr = this.props.deltaker.hund.katalogNr;
        let caciob = null;
        if (event.target.checked) {
            caciob = event.target.name;
        }

        this.props.caciobOppdatert(katalogNr, caciob);
    }

}
export default Deltaker;





// WEBPACK FOOTER //
// ./src/pages/deltakerliste/Deltaker.js